


/**
 * Attende che l'evento `DOMContentLoaded` venga emesso, indicando che il DOM è stato completamente caricato.
 *
 * @returns {Promise<void>} Una Promise che si risolve quando il DOM è pronto.
 *
 * @example
 * // Utilizzo del metodo per assicurarsi che il DOM sia caricato prima di eseguire codice
 * await PageBase.DOMLoaded();
 * console.log("Il DOM è pronto!");
 */
const DOMLoaded = async(): Promise<void> => {
    if (document.readyState === "loading") {
        await new Promise<void>((resolve) => {
            document.addEventListener("DOMContentLoaded", () => resolve());
        });
    }
}

export {DOMLoaded};